export const FirebaseConfig = {
	"projectId": "bid-magnet",
	"appId": "1:150593544230:web:0852e5ac65b19e564886e7",
	"databaseURL": "https://bid-magnet-default-rtdb.firebaseio.com",
	"storageBucket": "bid-magnet.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCH5dR8htzajdKr9GeB3mkJYK3AQStH6nk",
	"authDomain": "bid-magnet.firebaseapp.com",
	"messagingSenderId": "150593544230"
};